import { fg } from '@atlassian/jira-feature-gating';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { helpCenterSettingsGetStartedRoute } from '@atlassian/jira-router-routes-help-center-settings-routes/src/helpCenterSettingsGetStartedRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { getStartedPropertyResource } from '@atlassian/jira-router-resources-service-desk-customer-service-get-started-property/src/services/get-started-property/index.tsx';
import { navigation } from './common/constants.tsx';
import { helpCenterSettingGetStartedAppPageEntryPoint } from './ui/get-started/index.tsx';

export const helpCenterSettingsGetStartedRouteEntry = createEntry(
	helpCenterSettingsGetStartedRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.get-started',
		layout: serviceProjectLayout,
		navigation,
		component: ErrorPagesNotFound,

		entryPoint() {
			return fg('csm-onboarding') ? helpCenterSettingGetStartedAppPageEntryPoint : undefined;
		},

		resources: [getStartedPropertyResource],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsGetStartedRouteEntry.tsx',
				whichExportToUse: 'helpCenterSettingsGetStartedRouteEntry',
			},

			enabled: true,
		},
	}),
);
